import * as React from 'react';
import { SVGProps } from 'react';

const IconPressureFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 5.5A4.5 4.5 0 0 1 8 9.532V10h1v1H3v-1h1v-.468A4.5 4.5 0 1 1 10.5 5.5ZM6 6.5c.089 0 .175-.012.257-.033l.574.648.771-.771-.64-.568A1 1 0 0 0 5.61 4.58L4.226 3.354l-.385.386 1.23 1.389A1 1 0 0 0 6 6.5Z"
    />
  </svg>
);
export default IconPressureFilledSizeXs;
